function updateCartDrawer(opencart=true) {
  jQuery.get('/cart?view=json', function(data) {
    jQuery('.cart-flyout').html(data);
    if (typeof Currency !== 'undefined' && jQuery('[name=currencies]').val()) {
      Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
    }
  });
  Shopify.getCart(function(cart) {
    jQuery('.la-cart-count').html(cart.item_count);
  });
  if(opencart){
      jQuery('body').addClass('open-cart-aside');
    }
}